import { Car, CalendarClock, BadgeCheck, ScrollText } from "lucide-react";

const POINTS = [
  {
    icon: Car,
    title: "Mobile & Convenient",
    body: "I travel to your home, office, hospital, or care facility.",
  },
  {
    icon: CalendarClock,
    title: "Flexible Hours",
    body: "Days, evenings, and weekends by appointment.",
  },
  {
    icon: ScrollText,
    title: "Transparent Pricing",
    body: "Know the exact cost before I arrive — always.",
  },
  {
    icon: BadgeCheck,
    title: "Professional",
    body: "Commissioned Illinois Notary Public.",
  },
];

export const WhyChoose = () => (
  <section
    id="why-choose"
    data-testid="why-choose-section"
    className="section-pad bg-navy relative overflow-hidden"
  >
    <div aria-hidden="true" className="absolute inset-0 opacity-[0.06]" style={{ background: "radial-gradient(circle at 20% 20%, #c9a227 0%, transparent 40%), radial-gradient(circle at 80% 80%, #c9a227 0%, transparent 40%)" }} />
    <div className="container-tn relative">
      <div className="max-w-3xl">
        <span className="font-serif uppercase tracking-[0.3em] text-xs sm:text-sm text-gold">
          Why Choose Trusted Notary Illinois
        </span>
        <span className="block h-px w-16 bg-gold my-6" />
        <h2 className="font-serif text-white uppercase text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
          Reliable. Local.<br />
          <span className="text-gold">On your schedule.</span>
        </h2>
      </div>

      <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
        {POINTS.map(({ icon: Icon, title, body }) => (
          <div
            key={title}
            data-testid={`why-point-${title.replace(/\s+/g, "-").toLowerCase()}`}
            className="group"
          >
            <div className="flex items-center justify-center w-14 h-14 rounded-md bg-white/[0.06] border border-gold/40 group-hover:border-gold transition-colors">
              <Icon className="w-7 h-7 text-gold" strokeWidth={1.75} />
            </div>
            <h3 className="mt-5 font-serif text-white uppercase text-base sm:text-lg tracking-[0.1em] font-semibold">
              {title}
            </h3>
            <p className="mt-2 text-white/70 text-sm sm:text-base leading-relaxed">{body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
